module.exports = __webpack_public_path__ + "static/media/MC.e30f04f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MC.svg
// module id = 2203
// module chunks = 7